import React from "react";

const TyreSVG: React.FunctionComponent = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none">
    <rect width="24" height="24" rx="12" fill="#E5E8E9" />
    <path
      d="M12 18a6 6 0 1 0 0-12 6 6 0 1 0 0 12Zm.75-6a.75.75 0 1 0-1.499-.001.75.75 0 0 0 1.499.001Zm-.377 1.453v1.524a2.998 2.998 0 0 0 2.339-1.697l-1.451-.471a1.5 1.5 0 0 1-.89.647l.002-.003Zm1.122-1.36 1.449.472a2.999 2.999 0 0 0-.89-2.754l-.896 1.233c.213.258.34.59.34.951 0 .033 0 .064-.003.094v.005Zm-.942-1.488.895-1.232a2.991 2.991 0 0 0-2.896 0l.658.909.234.323a1.498 1.498 0 0 1 1.107 0h.002Zm-2.608-.792a2.996 2.996 0 0 0-.891 2.754l1.448-.473c-.002-.03-.002-.063-.002-.094 0-.36.129-.694.34-.952l-.237-.325-.658-.907v-.003Zm.79 2.993-1.451.471c.428.91 1.3 1.568 2.339 1.697v-1.523a1.508 1.508 0 0 1-.889-.645ZM12 15.75A3.749 3.749 0 0 1 8.25 12 3.749 3.749 0 0 1 12 8.25 3.749 3.749 0 0 1 15.75 12 3.749 3.749 0 0 1 12 15.75Z"
      fill="#1D2948"
    />
  </svg>
);

export default TyreSVG;
